import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    highLightLabel: {
      '& .MuiTypography-root': {
        fontWeight: 'bold',
      },
    },
    shrunk: {
      marginLeft: '-11px',
      marginRight: '5px',
      minWidth: '70px',
      '& .MuiCheckbox-root': {
        marginRight: '-7px',
      },
    },
    subOptionsInline: {
      display: '-webkit-box',
    },
    styleSubSystem: {
      marginRight: '36px',
      '& .MuiTypography-root': {
        fontWeight: 'bold',
      },
    },
    styleFieldOptionsLabels: {
      '& .MuiTypography-body1': {
        fontSize: '0.8rem',
      },
    },
  }),
);
